import gql from 'graphql-tag';

export const _GET_PARTICIPANT_USERS = gql`
	query gqlPeople_getParticipantUsers($participant: uuid!, $legal_entity: uuid) {
		participantUsers: risolto_participant_user(
			where: { 
				_and: {
						participant: { _eq: $participant },
						legal_entity: { _eq: $legal_entity },
						internal: { _eq: false },
						deactivated_at: { _is_null: true }
					}
				}
		) {
			person_by_reference {
				reference
				username
				email
			}
		}
	}
`;

export const _GET_PERSON_BY_EXTERNAL_ID = gql`
	query gqlPeople_getPersonByExternalId($externalId: String!) {
		risolto_person(where: { external_id: { _eq: $externalId } }) {
			reference
			username
		}
	}
`;

export const _GET_PARTICIPANT_BY_PERSON = gql`
	query gqlPeople_getParticipantByPerson($personRef: uuid!) {
		risolto_participant_user(where: { person: { _eq: $personRef } }) {
			reference
			participant
		}
	}
`;
